import React from 'react';
import {Modal, View, TouchableWithoutFeedback} from 'react-native';

import {
  Description,
  Container,
  ModalOverlay,
  ModalContent,
  Header,
  CloseButton,
  CloseButtonText,
  ModalFooter,
} from './styles';
import {Titles} from '../../Interface/Typographies/Titles';

import {Button} from '../../Interface/Forms/Buttons/Button';
import {useNavigation} from '@react-navigation/native';
import {useAuth} from '../../../context/auth';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function PromoMarqueeModal({isOpen, onClose}: Props) {
  const {isLogged, openSign} = useAuth();
  const navigation = useNavigation();

  function handleRedirect() {
    if (isLogged) {
      onClose();
      navigation.navigate('Reembolsos');
    } else {
      onClose();
      openSign();
    }
  }

  return (
    <Modal
      visible={isOpen}
      onRequestClose={onClose}
      transparent
      animationType="fade">
      <ModalOverlay>
        <TouchableWithoutFeedback onPress={onClose}>
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          />
        </TouchableWithoutFeedback>
        <ModalContent>
          <Header>
            <CloseButton onPress={onClose}>
              <CloseButtonText>✕</CloseButtonText>
            </CloseButton>
          </Header>
          <Container>
            <Titles
              title="Garantia do Menor Preço ou seu dinheiro de volta!"
            />
            <Description style={{ marginTop: 16 }}>
              Aqui é simples: você compra pelo aplicativo e, ao chegar no posto,
              se não estiver satisfeito com o preço, ANTES de abastecer você pode solicitar
              o reembolso integral, sem qualquer burocracia.
            </Description>

            <Description>
              Nosso compromisso é garantir o menor preço em todo o Brasil, com
              transparência total e confiança na palma da sua mão.
            </Description>
          </Container>

          <ModalFooter>
            <Button
              title="Solicitar reembolso"
              onPress={() => handleRedirect()}
              enabled
            />
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}
